import { render, staticRenderFns } from "./AddTeam.vue?vue&type=template&id=3149019a&scoped=true"
import script from "./AddTeam.vue?vue&type=script&lang=js"
export * from "./AddTeam.vue?vue&type=script&lang=js"
import style0 from "./AddTeam.vue?vue&type=style&index=0&id=3149019a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3149019a",
  null
  
)

export default component.exports